module.exports = __webpack_public_path__ + "res/dummy_map.012e1ede4d7f5fc3187489e8837408b0.png";